import { useEffect, useState } from "react";
import api from "@/lib/api";
import { UserCheck } from "lucide-react";

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

// Suggests existing client sheets while typing a name, to avoid duplicates
export const ClientSuggest = ({ query, onPick, t }) => {
  const [clients, setClients] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [picked, setPicked] = useState("");
  useEffect(() => { api.get("/clients").then(({ data }) => setClients(data)).catch(() => setClients([])); }, []);
  useEffect(() => { if (norm(query) !== picked) setHidden(false); }, [query, picked]);
  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") setHidden(true); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, []);
  const q = norm(query);
  if (!clients || q.length < 2 || hidden) return null;
  const hits = clients.filter((c) => [c.name, c.firstname, c.company, `${c.name} ${c.firstname}`, `${c.firstname} ${c.name}`].some((v) => norm(v).includes(q))).slice(0, 6);
  if (!hits.length) return null;
  return (
    <div className="absolute z-40 left-0 right-0 mt-1 rounded-lg border border-primary/40 bg-card shadow-lg" data-testid="client-suggest">
      <div className="px-3 py-1.5 text-[11px] font-semibold text-primary border-b border-border">{t("Clients existants : cliquez pour reprendre la fiche")}</div>
      {hits.map((c) => (
        <button key={c.id} type="button" onClick={() => { setPicked(norm(c.name)); setHidden(true); onPick(c); }} data-testid={`client-suggest-${c.id}`}
          className="w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2">
          <UserCheck className="w-4 h-4 text-primary shrink-0" />
          <span className="font-medium">{[(c.name || "").toUpperCase(), c.firstname].filter(Boolean).join(" ")}</span>
          <span className="text-xs text-muted-foreground truncate">{[c.company, c.email, [c.postal, c.city].filter(Boolean).join(" ")].filter(Boolean).join(" · ")}</span>
        </button>
      ))}
      <button type="button" onClick={() => setHidden(true)} className="w-full px-3 py-1.5 text-xs text-muted-foreground hover:bg-muted border-t border-border" data-testid="client-suggest-new">
        {t("Non, c'est un nouveau client")}
      </button>
    </div>
  );
};
